import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class RoleService {

    static getRolesList = params => {
        return axios.get(PATH.GET_ROLE_LIST, {params});
    }

    static addRole = data => {
        return axios.post(PATH.POST_ROLE_URL, data);
    }

    static getRoleById = id => {
        return axios.get(`${PATH.GET_ROLE_BY_ID}/${id}`);
    }

    static editRole = (id, data) => {
        return axios.put(`${PATH.UPDATE_ROLE_URL}/${id}`, data);
    }

    static getAllPermission = () => {
        return axios.get(PATH.ALL_PERMISSION_URL);
    }

}
